// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3OySh","location":"Header_location__ERG-P"};